import {OpenStreetMapComponent} from '@components/openstreetmap/openstreetmap.component';

export type BidMapLatLngBounds = {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
};

export function getBidMapBounds(osm: OpenStreetMapComponent): BidMapLatLngBounds | null {
  try {
    const m = osm.getMapInstance();
    const b = m?.getBounds?.();
    if (!b) {
      return null;
    }
    return {
      minLat: b.getSouth(),
      maxLat: b.getNorth(),
      minLng: b.getWest(),
      maxLng: b.getEast(),
    };
  } catch {
    return null;
  }
}

export function latLngRingToBounds(ring: [number, number][]): BidMapLatLngBounds | null {
  if (!ring.length) {
    return null;
  }
  let minLat = Infinity;
  let maxLat = -Infinity;
  let minLng = Infinity;
  let maxLng = -Infinity;
  for (const [lat, lng] of ring) {
    if (lat < minLat) {
      minLat = lat;
    }
    if (lat > maxLat) {
      maxLat = lat;
    }
    if (lng < minLng) {
      minLng = lng;
    }
    if (lng > maxLng) {
      maxLng = lng;
    }
  }
  if (!Number.isFinite(minLat) || !Number.isFinite(maxLat)) {
    return null;
  }
  return {minLat, maxLat, minLng, maxLng};
}

export function padLatLngBounds(bounds: BidMapLatLngBounds, padDeg: number): BidMapLatLngBounds {
  return {
    minLat: Math.max(-90, bounds.minLat - padDeg),
    maxLat: Math.min(90, bounds.maxLat + padDeg),
    minLng: Math.max(-180, bounds.minLng - padDeg),
    maxLng: Math.min(180, bounds.maxLng + padDeg),
  };
}
